var map = {
	"./app-modules/access-group/access-group.module": [
		"./src/app/app-modules/access-group/access-group.module.ts",
		"access-group.module"
	],
	"./app-modules/dashboard/dashboard.module": [
		"./src/app/app-modules/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./app-modules/detail/detail.module": [
		"./src/app/app-modules/detail/detail.module.ts",
		"common",
		"detail.module"
	],
	"./app-modules/dynamic/dynamic.module": [
		"./src/app/app-modules/dynamic/dynamic.module.ts",
		"common"
	],
	"./app-modules/home/home.module": [
		"./src/app/app-modules/home/home.module.ts",
		"home.module"
	],
	"./app-modules/list/list.module": [
		"./src/app/app-modules/list/list.module.ts",
		"list.module"
	],
	"./app-modules/play/play.module": [
		"./src/app/app-modules/play/play.module.ts",
		"common",
		"play.module"
	],
	"./app-modules/report/report.module": [
		"./src/app/app-modules/report/report.module.ts",
		"report.module"
	],
	"./app-modules/settings/settings.module": [
		"./src/app/app-modules/settings/settings.module.ts",
		"settings.module"
	],
	"./app-modules/view/view.module": [
		"./src/app/app-modules/view/view.module.ts",
		"common",
		"view.module"
	],
	"./platform-tools/setup.module": [
		"./src/app/platform-tools/setup.module.ts",
		"setup.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main